module.exports = __webpack_public_path__ + "img/2.10df9374.png";